import { FunctionComponent } from 'react';

import { imageResizer } from 'utils/image';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutArticleAuthor: FunctionComponent<Props> = ({ authorImage, authorName, authorDescription }) => {
    return (
        <StyledComponent className="public-layout-articles-author">
            <div className="article-author">
                {authorImage && (
                    <div
                        className="author-image"
                        style={{ backgroundImage: `url(${imageResizer(authorImage, { width: 150 })})` }}
                    />
                )}
                <div className="author-data" >
                    <div
                        className="author-name"
                        dangerouslySetInnerHTML={{ __html: authorName }}
                    />
                    {authorDescription && (
                        <div
                            className="author-description"
                            dangerouslySetInnerHTML={{ __html: authorDescription }}
                        />
                    )}
                </div>
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutArticleAuthor;